/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { MOCK_DB_COMPANY_SITES, DB_SITE_GATES } from '../mocks/site'
import { ApiSiteWGates } from '../models/api'
import { Site } from '../models/client/site'
import { ValidationError } from '../util/errors/ValidationError'

import { apiRequest } from './apiRequest'
import { timeoutRequest, translateSite } from './tools'

const getCompanySites = async ({
  token,
  companyId,
}: {
  companyId: string
  token: string
}): Promise<Site[]> => {
  const { data } = await apiRequest<ApiSiteWGates[]>({
    path: '/sites',
    token,
    method: 'GET',
    include: ['gates', 'locations'],
    parameters: { 'filter[companyId]': companyId },
  })

  const sites: Site[] = []
  data.forEach((item) => {
    try {
      if (!item.meta.isDisabled) {
        sites.push(translateSite(item))
      }
    } catch (e) {
      if (e instanceof ValidationError) {
        return
      }
      throw e
    }
  })
  return sites
}

export const siteClient = {
  getCompanySites,
}
